// extracted by mini-css-extract-plugin
module.exports = {"section":"_2hS4E","iconsSection":"_3_RD8","titleSection":"_1yDBm","mobileTabs":"_2xUJ2"};